<template>
  <div id="payroll-one">
    <div class="select-month">
      <span class='title'>Month</span>
      <el-date-picker v-model="month"
                      type="month"
                      placeholder="select month"
                      value-format="yyyy-MM">
      </el-date-picker>
      <el-radio v-model="halfRadio"
                label="1">first half</el-radio>
      <el-radio v-model="halfRadio"
                label="2">second half</el-radio>
      <button class="search-btn"
              @click="getPayroll()">Search</button>
    </div>
    <ul class="table"
        v-if="isData">
      <li>
        <div>Work ID</div>
        <div>{{payrollObj.teaNo}}</div>
      </li>
      <li>
        <div>Position</div>
        <div v-if="payrollObj.probation===1">Full Time</div>
        <div v-else>Administrative</div>
      </li>
      <li>
        <div>Level</div>
        <div>{{payrollObj.levelNameEn}}</div>
      </li>
      <li>
        <div>Rate</div>
        <div>{{payrollObj.rate}}</div>
      </li>
      <li>
        <div>Basic Salary</div>
        <div>{{payrollObj.basicSalary}}</div>
      </li>
      <li>
        <div>Allowance</div>
        <div>{{payrollObj.allowance}}</div>
      </li>
      <li>
        <div>Open Class</div>
        <div>{{payrollObj.ocClass}}</div>
      </li>
      <li>
        <div>Open Class Remuneration</div>
        <div>{{payrollObj.ocRemuneration}}</div>
      </li>
      <li>
        <div>1V1 Class</div>
        <div>{{payrollObj.otoClass}}</div>
      </li>
      <li>
        <div>1V1 Class Remuneration</div>
        <div>{{payrollObj.otoRemuneration}}</div>
      </li>
      <li>
        <div>Group Class</div>
        <div>{{payrollObj.gcClass}}</div>
      </li>
      <li>
        <div>Group Class Remuneration</div>
        <div>{{payrollObj.gcRemuneration}}</div>
      </li>
      <li>
        <div>EXP Class</div>
        <div>{{payrollObj.expClass}}</div>
      </li>
      <li>
        <div>Assessment Class</div>
        <div>{{payrollObj.assessmentClass}}</div>
      </li>
      <li>
        <div>Total Lesson Remuneration</div>
        <div>{{payrollObj.totalRemuneration}}</div>
      </li>
      <li>
        <div>EXP Class Bonus</div>
        <div>{{payrollObj.expClassBonus}}</div>
      </li>
      <li>
        <div>Attendance Bonus</div>
        <div>{{payrollObj.attendanceBonus}}</div>
      </li>
      <li>
        <div>Performance Bonus</div>
        <div>{{payrollObj.performanceBonus}}</div>
      </li>
      <li>
        <div>Teacher of the Month</div>
        <div>{{payrollObj.teacherOfTheMonth}}</div>
      </li>
      <li>
        <div>Referal Bonus</div>
        <div>{{payrollObj.referalBonus}}</div>
      </li>
      <li>
        <div>Tenurity Bonus</div>
        <div>{{payrollObj.tenurityBonus}}</div>
      </li>
      <li>
        <div>Total Bonus</div>
        <div>{{payrollObj.totalBonus}}</div>
      </li>
      <li>
        <div>A With N</div>
        <div>{{payrollObj.awithN}}</div>
      </li>
      <li>
        <div>A With N Deduction</div>
        <div>{{payrollObj.awithNDeduction}}</div>
      </li>
      <li>
        <div>A Without N</div>
        <div>{{payrollObj.awithoutN}}</div>
      </li>
      <li>
        <div>A Without N Deduction</div>
        <div>{{payrollObj.awithoutNDeduction}}</div>
      </li>
      <li>
        <div>Late</div>
        <div>{{payrollObj.late}}</div>
      </li>
      <li>
        <div>Late Deduction</div>
        <div>{{payrollObj.lateDeduction}}</div>
      </li>
      <li>
        <div>Complaint</div>
        <div>{{payrollObj.complaint}}</div>
      </li>
      <li>
        <div>Complaint Deduction</div>
        <div>{{payrollObj.complaintDeduction}}</div>
      </li>
      <li>
        <div>Insufficient Class Time</div>
        <div>{{payrollObj.insufficientClassTime}}</div>
      </li>
      <li>
        <div>Insufficient Class Time Deduction</div>
        <div>{{payrollObj.insufficientTimeDeduction}}</div>
      </li>
      <li>
        <div>Insufficient Opened Class</div>
        <div>{{payrollObj.insufficientOpenedClass}}</div>
      </li>
      <li>
        <div>Insufficient Opened Class Deduction</div>
        <div>{{payrollObj.insufficientOpenedDeduction}}</div>
      </li>
      <li>
        <div>Tenurity Bonus Deduction</div>
        <div>{{payrollObj.tenurityBonusDeduction}}</div>
      </li>
      <li>
        <div>Total Deductions</div>
        <div>{{payrollObj.totalDeductions}}</div>
      </li>
      <li>
        <div>Personal Tax</div>
        <div>{{payrollObj.personalTax}}</div>
      </li>
      <li>
        <div>EMPLOYEE's SHARE SSS</div>
        <div>{{payrollObj.employeeShareSss}}</div>
      </li>
      <li>
        <div>EMPLOYEE's SHARE PHiLHealth</div>
        <div>{{payrollObj.employeeSharePhilhealth}}</div>
      </li>
      <li>
        <div>Pag-ibig</div>
        <div>{{payrollObj.pagIbig}}</div>
      </li>
      <li>
        <div>TOTAL</div>
        <div>{{payrollObj.total}}</div>
      </li>
    </ul>
  </div>
</template>
<script>
import './index.less';
import timeTools from '@/utils/timeTools';
export default {
  data() {
    return {
      month: timeTools.getPreMonth(new Date()).slice(0, 7),
      halfRadio: '1',
      payrollObj: {},
      isData: false,
    };
  },
  methods: {
    async getPayroll() {
      const res = await this.$api.getBasePayroll(this.month, parseInt(this.halfRadio));
      if (res.data.hasOwnProperty('resultData')) {
        this.isData = true;
        this.payrollObj = res.data.resultData;
      } else {
        this.isData = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/PayrollOne/index.vue